import { useLocale } from "@/hooks/useLocale";
import { format as formatDateFns } from "date-fns";
import { useMemo } from "react";

const useMonthNames = (format = "LLLL", year = new Date().getFullYear()) => {
  const locale = useLocale();

  const months = useMemo(() => {
    const monthNames = [];

    for (let month = 0; month < 12; month++) {
      const date = new Date(year, month, 1);
      monthNames.push(formatDateFns(date, format, { locale }));
    }

    return monthNames;
  }, [format, locale, year]);

  return months;
};

export default useMonthNames;
